module.exports = __webpack_public_path__ + "img/tu03.c5d14c92.png";